import React from "react";
import { useDietPlanTab, DietPlanTabContext } from "./useDietPlanTab";
import DietPlanView from "./DietPlanView";

export default function DietPlanTab(props) {
  const value = useDietPlanTab(props);
  return (
    <DietPlanTabContext.Provider value={value}>
      <DietPlanView />
    </DietPlanTabContext.Provider>
  );
}
